module.exports = __webpack_public_path__ + "static/media/26UNRWA2.4ec79f3f.jpg";